<template src='./new.pug' lang='pug'></template>

<script>
import _ from 'underscore'
import vSelect from 'vue-select'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'
import customSorter from '../../../../utils/customSorter.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import PerfilAcessoEnum from '../../../../enum/perfilAcessoEnum'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'OperatorNew',

  components: {
    vSelect,
    PageTitle,
    FilterPortlet,
    ButtonPrimary
  },

  data () {
    return {
      requestSent: false,
      operator: {
        name: '',
        email: '',
        status: null,
        accessProfile: {
          id: '',
          nome: ''
        }
      },
      profiles: [],
      loggedUserProfileId: this.$store.getters.accessProfileId
    }
  },

  computed: {
    operatorToEdit () {
      return this.$store.getters.operatorToEditId
    },
    profileList () {
      return _.sortBy(this.profiles, function (item) {
        return customSorter.cleanLowerString(item.nome)
      }, 'asc')
    },

    filterPortletTitle () {
      return this.operatorToEdit ? this.$t('administracao.operadores.labels.editarOperador')
        : this.$t('administracao.operadores.labels.novoOperador')
    }
  },

  watch: {
    operator: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.operator))
      },
      deep: true
    }
  },

  methods: {
    isMasterProfile () {
      return Number(this.loggedUserProfileId) === PerfilAcessoEnum.MASTER
    },

    setOperatorProfile (val) {
      if (val) {
        if (!this.operator.accessProfile) this.operator.accessProfile = {}
        this.operator.accessProfile.id = val.id
        this.operator.accessProfile.nome = val.nome
      } else {
        this.operator.accessProfile = null
      }
    },

    loadProfiles () {
      let url = 'operator/operatorsProfiles'
      this.$store.dispatch('getOperatorProfiles', url)
        .then((response) => {
          this.profiles = this.isMasterProfile()
            ? response.data
            : response.data.filter(item => item.id.toString() !== '2')
          if (this.operatorToEdit) {
            this.loadOperator()
          } else {
            this.defaultObject = { ...this.operator, accessProfile: { ...this.operator.accessProfile } }
          }
        })
    },

    newOperator () {
      this.operator.operatorId = this.operatorToEdit
      let oper = {
        accessProfileId: this.operator.accessProfile.id,
        email: this.operator.email,
        name: this.operator.name,
        operatorId: this.operator.operatorId,
        sex: '', // burla validação do MS authorization. Não existe regra no banco.
        status: this.operator.status,
        url: 'http://' + window.location.host + '/banking/'
      }

      this.requestSent = true
      this.$store.dispatch('newOperator', oper)
        .then((response) => {
          this.$root.$refs.notification.success(response.data)
          trackAnalyticsEvent(this, 'perfil-de-acesso', 'perfil-de-acesso-escolhido', oper.accessProfileId)
          this.$store.dispatch('setHasUnsavedChanges', false)
          this.$router.push(PATHS.LIST_OPERATORS)
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
        .finally(() => {
          this.requestSent = false
        })
    },

    loadOperator () {
      this.$store.dispatch('getOperator', this.operatorToEdit)
        .then((response) => {
          this.operator = {
            name: response.data.name,
            email: response.data.email,
            status: response.data.ativo,
            accessProfile: {
              id: response.data.perfilAcesso.id,
              nome: response.data.perfilAcesso.nome
            }
          }
          this.defaultObject = { ...this.operator, accessProfile: { ...this.operator.accessProfile } }
        })
    },

    validate (event) {
      event.preventDefault()
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.newOperator()
          } else {
            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'administracao.operadores.erro.criar')
          }
        })
    },

    back () {
      this.$router.push(PATHS.LIST_OPERATORS)
    }

  },

  created () {
    this.loadProfiles()
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
    this.$store.dispatch('cleanOperatorToEdit')
  }
}
</script>



// WEBPACK FOOTER //
// New.vue?83bbced4